<form [formGroup]="editForm">
  <div class="form-row row">
    <div class="form-group col-12">
      <label for="name" class="control-label required">{{ 'i18n.domain.assets.asset-collections.name' | translate
        }}</label>
      <input id="name" type="text" class="form-control" formControlName="name" />
      <app-error-messages [control]="editForm.controls.name"></app-error-messages>
    </div>
  </div>
  <div class="form-group col-12">
    <div class="d-flex gap-1">
      <label for="token" class="control-label">{{ 'i18n.domain.assets.asset-collections.token' | translate }}</label>
      <ejs-tooltip id='tooltip' content="{{ 'i18n.domain.assets.asset-collections.edit.tooltip' | translate }}">
        <span class="icon-information"></span>
      </ejs-tooltip>
    </div>
    <div class="input-group">
      <input id="token" type="text" class="form-control" formControlName="token" />
      <button class="btn btn-icon e-icons icon-renew btn-secondary"
        title="{{ 'i18n.domain.import-configuration.edit.rest.generate' | translate }}"
        (click)="generateToken()"></button>
    </div>
    <app-error-messages [control]="editForm.controls.token"></app-error-messages>
  </div>
  <div class="form-row row">
    <div class="form-group col-6">
      <label class="control-label required">{{ 'i18n.domain.assets.asset-collections.shared' | translate }}</label>
      <app-yes-no-group-button id="shared" [formControl]="editForm.controls.isShared"></app-yes-no-group-button>
    </div>
    <div class="form-group col-6">
      <label for="sharedUntilDate" class="control-label">{{ 'i18n.domain.assets.asset-collections.shared-until' |
        translate }}</label>
      <ejs-datepicker #ejTimePicker formControlName="sharedUntilDate" id="sharedUntilDate" class="dtpkr"
        format="dd.MM.yyyy"></ejs-datepicker>
      <app-error-messages [control]="editForm.controls.sharedUntilDate"></app-error-messages>
    </div>
  </div>
  <hr>
  @if(editForm.controls.id.value){
    <div class="form-row row">
      <div class="form-group col-12">
        <label class="fs-5 mb-1">{{ 'i18n.domain.assets.asset-collections.edit.assigned-assets' | translate }}</label>
        <ejs-grid #grid class="grid" width='100%' rowHeight='38' [dataSource]='assets' [allowSorting]='true'
          [filterSettings]='filterSettings' [allowFiltering]='true' [allowPaging]='true' [pageSettings]='pageSettings'
          (actionBegin)="actionBegin($event)" (actionComplete)="actionComplete($event)"
          (commandClick)="commandClicked($event)">
          <e-columns>
            <e-column field='id' [visible]='false' [isPrimaryKey]='true'></e-column>
            <e-column headerText="{{'i18n.domain.assets.asset-collections.edit.preview' | translate}}"
              clipMode='EllipsisWithTooltip' type="string" [allowFiltering]="false" [allowSorting]="false" width="100px">
              <ng-template #template let-data>
                @if(data.isFile){
                  <div class="asset-preview">
                    <a [href]="data.fileLink" target="_blank">
                      <img src="{{getPreviewLink(data)}}"
                        [alt]="data.altText ?? ('i18n.domain.assets.product-assets.subgrid.image-not-available' | translate)"
                        onerror="" />
                    </a>
                  </div>
                }
                @if(!data.isFile){
                  <div class="icon-folder h2 text-center"></div>
                }
              </ng-template>
            </e-column>
            <e-column field='RelativePathAndName'
              headerText="{{'i18n.domain.assets.asset-collections.edit.local-file-name' | translate}}"
              clipMode='EllipsisWithTooltip' type="string">
              <ng-template #template let-data>
                <div>{{getLocalFileName(data)}}</div>
              </ng-template>
            </e-column>
            <e-column field='PublicName'
              headerText="{{'i18n.domain.assets.asset-collections.edit.public-file-name' | translate}}"
              clipMode='EllipsisWithTooltip' type="string">
              <ng-template #template let-data>
                <div>{{getPublicFileName(data)}}</div>
              </ng-template>
            </e-column>
            <e-column field='RelativePathAndName'
              headerText="{{'i18n.domain.assets.asset-collections.edit.file-name-extension' | translate}}"
              clipMode='EllipsisWithTooltip' type="string">
              <ng-template #template let-data>
                <div>{{getFileEnding(data)}}</div>
              </ng-template>
            </e-column>
            <e-column headerText="" [commands]='gridCommands' [allowFiltering]="false" textAlign="left"
              width="55px"></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
  }
</form>
